import React from 'react';
import 'reflect-metadata';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { CacheProvider, Global } from '@emotion/react';
import createCache from '@emotion/cache';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { ThemeProvider } from 'theme-ui';
import { theme } from 'theme';
import styles from './styles';

const isDev = (process.env.NODE_ENV === 'development');

// Disable vendor prefixes in development
const emotionCache = createCache({
  key: 'emo',
  ...(isDev && { stylisPlugins: [] }),
});

ReactDOM.render(
  // <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider getPopupContainer={trigger => trigger.parentElement}>
        <ThemeProvider theme={theme}>
          <CacheProvider value={emotionCache}>
            <Global styles={styles} />
            <App />
          </CacheProvider>
        </ThemeProvider>
      </ConfigProvider>
    </BrowserRouter>
  // </React.StrictMode>
  , document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
